import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Storage from "@aws-amplify/storage";

// Components
import { Row, Col, FormGroup, FormLabel, FormFile } from "react-bootstrap";

const BackgroundImageUpload = ({
  handleUploadBgImage,
  backgroundImageKey,
  setPreviewImage = null,
}) => {
  const [bgImage, setBgImage] = useState({
    name: "Select an image",
    url: null,
  });

  useEffect(() => {
    async function fetchBgImageKey() {
      try {
        if (backgroundImageKey) {
          const url = await Storage.get(backgroundImageKey);
          setBgImage({
            name: "background-image",
            url,
          });

          if (setPreviewImage) {
            setPreviewImage(url);
          }
        }
      } catch (e) {
        setBgImage({
          name: "Select an image",
          url: null,
        });
      }
    }

    fetchBgImageKey();
  }, [backgroundImageKey, setPreviewImage]);

  const handleBackgroundImageChange = (event) => {
    event.preventDefault();
    let file = event.target.files[0];

    if (!file) return;

    // Update the "backgroundFile" and "displayBackground"
    handleUploadBgImage(file);

    // Render preview background image
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      setBgImage({ name: file.name, url: reader.result });

      if (setPreviewImage) {
        setPreviewImage(reader.result);
      }
    };
  };

  return (
    <>
      <Row className="mt-4 mb-2">
        <Col>
          <FormLabel
            className="setting-item-title"
            htmlFor="form-upload-image-custom"
          >
            Import Menu Background Image
          </FormLabel>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup controlId="formBackgroundFile">
            <FormFile id="form-upload-image-custom" custom>
              <div className="d-flex align-items-center menu-upload-file">
                <label
                  className="fileInput-label"
                  htmlFor="form-upload-image-custom"
                >
                  Choose file
                </label>
                <span
                  className="fileInput-name text-truncate"
                  htmlFor="form-upload-image-custom"
                >
                  {bgImage.name}
                </span>
              </div>
              <FormFile.Input
                name="selectedImage"
                accept="image/*"
                onChange={handleBackgroundImageChange}
                className="d-none"
              />
            </FormFile>
          </FormGroup>
        </Col>
      </Row>
      {bgImage.url && (
        <Row className="mt-4 mb-2 previewComponent-wrapper">
          <Col>
            <img
              src={bgImage.url}
              alt={`${bgImage.name}-preview`}
              height={200}
              width="100%"
            />
          </Col>
        </Row>
      )}
    </>
  );
};

BackgroundImageUpload.propTypes = {
  handleUploadBgImage: PropTypes.func.isRequired,
  backgroundImageKey: PropTypes.string,
  setPreviewImage: PropTypes.func,
};

export default BackgroundImageUpload;
